Vue.directive('fullcalendar', (el, bindings) => {
  $(document).ready(() => {
    const options = bindings.value;

    if (_.has(options, 'changeView')) {
      $(el).fullCalendar('changeView', options.changeView);

      return;
    }

    if (! _.has(options, 'refreshEvents')) {
      $(el).fullCalendar('destroy');
      $(el).fullCalendar(options);

      return;
    }

    const source = _.omit(options, 'refreshEvents');

    $(el).fullCalendar('removeEvents');
    $(el).fullCalendar('addEventSource', source);
  });
});
